var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgStbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 505,
    height: 243.48,
    viewBox: "0 0 505 243.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-131.4204 -203.55428)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.144677 0 0 -12.144677 372.6884 353.15356)",
    fill: "#ec008c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 9.81,9.81 5.865,0 L 5.9,0.035 15.693,-9.81 9.81,-9.819 0,0 z",
    transform: "translate(-19.6603 2.2947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 9.844,9.841 5.862,0 L 5.902,0.036 15.662,-9.779 9.777,-9.786 0,0 z",
    transform: "translate(-10.3575 2.2712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 2.976,-2.976 11.915,6.016 15.589,2.343 5.814,-7.511 11.849,-7.507 21.51,2.33 11.655,12.033 0,0 z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStbLogo);
export default __webpack_public_path__ + "static/media/stb-logo.7a78adc0285d13505865b8c2ed7fea80.svg";
export { ForwardRef as ReactComponent };